/**
 * Data field options: ids, order, availability and related guide.
 * Texts: i18n content/<lang>/datafields.ts (dfo.*). Option NAMES: settingsNames.ts (generated from the watch strings).
 */
import { settingsNames } from './settingsNames';
export function getOptionName(id, lang) {
    const entry = settingsNames[id];
    if (!entry)
        return id;
    return entry[lang] || entry['en'] || id;
}
export const settingsCategories = [
    {
        id: 'health',
        options: [
            { id: 'HR' },
            { id: 'HRC', availability: ['mip'] },
            { id: 'Ox' },
            { id: 'BB' },
            { id: 'Str' },
            { id: 'RR' },
            { id: 'TTR' },
            { id: 'slsc', availability: ['newest'] },
            { id: 'cgmv', availability: ['newer'] },
            { id: 'AVRHR' },
            { id: 'VO2MC' },
            { id: 'VO2MR' },
            { id: 'cTstT', availability: ['newer'] },
        ],
    },
    {
        id: 'activity',
        options: [
            { id: 'AMD' },
            { id: 'AMW' },
            { id: 'WCP', availability: ['newer'] },
            { id: 'WCD', availability: ['newer'] },
            { id: 'S' },
            { id: 'STSG' },
            { id: 'Di' },
            { id: 'FC' },
            { id: 'MC' },
            { id: 'C' },
            { id: 'ACTC' },
            { id: 'be' },
            { id: 'we' },
            { id: 'WEIG' },
        ],
    },
    {
        id: 'activityDistance',
        options: [
            { id: 'AWRD' },
            { id: 'A7RD' },
            { id: 'AMRD' },
            { id: 'AWCD' },
            { id: 'A7CD' },
            { id: 'AMCD' },
            { id: 'AWSD' },
            { id: 'A7SD' },
            { id: 'AMSD' },
            { id: 'AWHD' },
            { id: 'A7HD' },
            { id: 'AMHD' },
            { id: 'A7FT' },
        ],
    },
    {
        id: 'activityTime',
        options: [
            { id: 'AWRT', availability: ['newer'] },
            { id: 'A7RT', availability: ['newer'] },
            { id: 'AMRT', availability: ['newer'] },
            { id: 'AWCT', availability: ['newer'] },
            { id: 'A7CT', availability: ['newer'] },
            { id: 'AMCT', availability: ['newer'] },
            { id: 'AWST', availability: ['newer'] },
            { id: 'A7ST', availability: ['newer'] },
            { id: 'AMST', availability: ['newer'] },
            { id: 'AWFT', availability: ['newer'] },
            { id: 'AMFT', availability: ['newer'] },
        ],
    },
    {
        id: 'dateTime',
        options: [
            { id: 'D', relatedGuide: '/guides/date-format' },
            { id: 'D2', relatedGuide: '/guides/date-format' },
            { id: 'D12', relatedGuide: '/guides/date-format' },
            { id: 'tts' },
            { id: 'd2do', availability: ['newer'] },
            { id: 'TZ2', relatedGuide: '/guides/timezones' },
            { id: 'TZ3', relatedGuide: '/guides/timezones' },
            { id: 'net', availability: ['newer'] },
            { id: 'sn' },
        ],
    },
    {
        id: 'battery',
        options: [
            { id: 'B' },
            { id: 'BiDT' },
            { id: 'STT' },
            { id: 'So' },
            { id: 'SoC', availability: ['mip'] },
        ],
    },
    {
        id: 'altitude',
        options: [
            { id: 'HS' },
            { id: 'Pr' },
            { id: 'APr' },
        ],
    },
    {
        id: 'weather',
        options: [
            { id: 'CW', relatedGuide: '/guides/weather' },
            { id: 'FLT', relatedGuide: '/guides/weather' },
            { id: 'MMT', relatedGuide: '/guides/weather' },
            { id: 'CW2', relatedGuide: '/guides/weather' },
            { id: 'WH', relatedGuide: '/guides/weather' },
            { id: 'WPC', relatedGuide: '/guides/weather' },
            { id: 'UV', relatedGuide: '/guides/weather' },
            { id: 'AQI2', availability: ['newer'] },
            { id: 'DP', relatedGuide: '/guides/weather' },
            { id: 'WDL' },
            { id: 'WDT' },
            { id: 'WDD', relatedGuide: '/guides/weather' },
        ],
    },
    {
        id: 'sun',
        options: [
            { id: 'NGH', relatedGuide: '/guides/location' },
            { id: 'NSE', relatedGuide: '/guides/location' },
            { id: 'NBH', relatedGuide: '/guides/location' },
            { id: 'NDD', relatedGuide: '/guides/location' },
            { id: 'NNDD', relatedGuide: '/guides/location' },
            { id: 'TGH' },
            { id: 'TSE' },
            { id: 'TBH' },
            { id: 'TDD' },
            { id: 'TNDD' },
            { id: 'SR', relatedGuide: '/guides/location' },
            { id: 'SS', relatedGuide: '/guides/location' },
            { id: 'NADD', relatedGuide: '/guides/location' },
            { id: 'TADD', relatedGuide: '/guides/location' },
        ],
    },
    {
        id: 'moon',
        options: [
            { id: 'MR', relatedGuide: '/guides/location' },
            { id: 'MS', relatedGuide: '/guides/location' },
            { id: 'NMR' },
            { id: 'MP' },
            { id: 'MD' },
        ],
    },
    {
        id: 'tides',
        options: [
            { id: 'NTT', availability: ['newer'], relatedGuide: '/guides/tides' },
            { id: 'NTL', availability: ['newer'], relatedGuide: '/guides/tides' },
            { id: 'NTH', availability: ['newer'], relatedGuide: '/guides/tides' },
        ],
    },
    {
        id: 'charts',
        options: [
            { id: 'CHH', availability: ['blackhawk'] },
            { id: 'CHP', availability: ['blackhawk'] },
            { id: 'CHE', availability: ['blackhawk'] },
            { id: 'CHT', availability: ['blackhawk'] },
            { id: 'CHS', availability: ['blackhawk'] },
        ],
    },
    {
        id: 'other',
        options: [
            { id: 'N' },
            { id: 'ct', availability: ['newer'] },
            { id: 'MGRS', relatedGuide: '/guides/location' },
        ],
    },
];
